import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function TrustInsuranceLicensesWesternSahara() {

    return (
        <main className='main'>

            <IntroSection
                title="Trust & Insurance Licenses – Western Sahara"
                subtitle="Operate Fiduciary & Insurance Services under CRA Licensing"
                description="The <b>Capital Regulatory Authority (CRA)</b> of <b>Western Sahara</b> offers one of the <b>most accessible frameworks</b> for <b>Trust and Insurance Licenses</b>. With <b>no statutory capital requirements</b> and a <b>streamlined approval process</b>, <b>CRA</b> is ideal for <b>fiduciary firms</b>, <b>asset managers</b>, and <b>insurance providers</b> seeking <b>global operations</b> from an <b>offshore jurisdiction</b>."
                badges={
                    [
                        "Trust & Fiduciary Licenses",
                        "Insurance & Reinsurance Licenses",
                        "Captive & Niche Insurance Providers"
                    ]
                }
                buttonText="Request a Trust & Insurance Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/trust-insurance-licenses-western-sahara.png")}
                imageAlt="Western"
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Western Sahara?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "No Capital Requirement",
                                                text: "Unlike Bermuda, Cayman, or Mauritius"
                                            },
                                            {
                                                title: "Fast Approvals",
                                                text: "Licenses issued in 1–2 weeks"
                                            },
                                            {
                                                title: "Global Recognition",
                                                text: "Accepted in offshore fiduciary & insurance sectors"
                                            },
                                            {
                                                title: "Asset Protection Focused",
                                                text: "Ideal for private clients & HNWIs"
                                            },
                                            {
                                                title: "Affordable Setup & Renewal",
                                                text: "Significantly lower than EU & Tier-1 regulators"
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="What the Licenses Cover"
                        blocks={
                            [
                                {
                                    title: "Trust & Fiduciary License",
                                    items:
                                        [
                                            {
                                                text: "Fiduciary & trustee services"
                                            },
                                            {
                                                text: "Private client & family office management"
                                            },
                                            {
                                                text: "Asset protection structures"
                                            },
                                            {
                                                text: "Succession & estate planning"
                                            },
                                            {
                                                text: "Corporate fiduciary & nominee services"
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <LocationTimeline
                        title="Insurance & Reinsurance License"
                        subtitle='Provide insurance and risk management services offshore:'
                        item={
                            [
                                {
                                    text: "General insurance (life, health, property, casualty)"
                                },
                                {
                                    text: "Captive insurance structures for corporations"
                                },
                                {
                                    text: "Reinsurance services for global risk coverage"
                                },
                                {
                                    text: "Niche insurance (crypto, fintech, high-risk sectors)"
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of CRA Trust & Insurance Licenses'
                        services={
                            [
                                {
                                    title: "Global Market Reach",
                                    text: "Attract clients worldwide"
                                },
                                {
                                    title: "Banking Access",
                                    text: "Easier onboarding with offshore banks & PSPs"
                                },
                                {
                                    title: "Asset Protection & Risk Mitigation",
                                    text: "Trusted regulatory framework"
                                },
                                {
                                    title: "Flexible Services",
                                    text: "Operate trust, insurance, and reinsurance under one regime"
                                },
                                {
                                    title: "Affordable",
                                    text: "No capital requirement, low licensing fees"
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Consultation & Planning",
                                    text: "Define trust, insurance, or combined structure"
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Entity registration under CRA"
                                },
                                {
                                    title: "Compliance Preparation",
                                    text: "AML/KYC manuals, risk management, business plan"
                                },
                                {
                                    title: "Application Filing",
                                    text: "Offshore Advisory submits to CRA"
                                },
                                {
                                    title: "Approval & License Issuance",
                                    text: "Typically within 6–10 weeks"
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "6–10 weeks",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from USD 10,000+"
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "None"
                                },
                                {
                                    name: "Annual Costs",
                                    description: "competitive vs other offshore regulators"
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Authorized CRA agent with trust & insurance experience"
                                },
                                {
                                    text: "Full-service solution: incorporation, compliance, license filing"
                                },
                                {
                                    text: "Access to fiduciary software, captive structures, and reinsurance networks"
                                },
                                {
                                    text: "Guidance on banking, PSPs, and asset protection structures"
                                },
                                {
                                    text: "Transparent, step-by-step process"
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Ready to establish a trust or insurance business?"
                        description="With no capital requirements and fast approvals, CRA in Western Sahara offers one of the most efficient offshore licensing solutions."
                        buttonText="Book a CRA Trust & Insurance Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is there a capital requirement?",
        content: [
            { type: "answer", text: "No — CRA trust and insurance licenses have no minimum capital requirement." },
        ],
    },
    {
        question: "How long does it take to get licensed?",
        content: [
            { type: "answer", text: "Typically 1–2 weeks, depending on documentation." },
        ],
    },
    {
        question: "Can I combine trust and insurance under one company?",
        content: [
            { type: "answer", text: "Yes — CRA allows combined licensing for multi-service providers." },
        ],
    },
    {
        question: "What services can a trust license cover?",
        content: [
            { type: "answer", text: "Trustee services, asset protection, succession planning, family office management." },
        ],
    },
    {
        question: "Can insurance include captives or reinsurance?",
        content: [
            { type: "answer", text: "Yes — CRA issues licenses for general, captive, and reinsurance structures." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We launched a fiduciary company under CRA with Offshore Advisory’s help. Fast and professional service.",
            author: "Elena P.",
            role: "Fiduciary Director"
        },
        {
            quote: "Offshore Advisory guided us through a CRA insurance license, allowing us to structure captive coverage for our corporate group.",
            author: "Michael R.",
            role: "Corporate CFO"
        }
    ]
;
